import * as Yup from 'yup';
import { TemplateFormGrid } from '../interfaces/template-form';

export function TemplateFormValidationFactory(formGrids: TemplateFormGrid[]): Yup.ObjectSchema {
  let validationSchema = Yup.object().shape({});

  formGrids.forEach(grid => {
    grid.fields.forEach(field => {
      validationSchema = validationSchema.concat(field.validationSchema);
    });
  });

  return validationSchema;
}
